import {Brick, registerBrick} from 'olympe';

/**
 * This brick removes all non ASCII characters from a string
 */
export default class RemoveNonASCIICharacters extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} inputString
     * @param {function(string)} setStringWithoutNonASCII
     */
    update($, [inputString], [setStringWithoutNonASCII]) {
        setStringWithoutNonASCII(inputString.replace(/[^\x00-\x7F]/g, ''));
    }
}

registerBrick('0182916b710bdb028ef6', RemoveNonASCIICharacters);
